<template dark>
  <div class="renderPage">
    <v-tabs
      background-color="primary"
      icons-and-text
      fixed-tabs
      center-active
      v-model="tab2"
    >
      <v-tabs-slider color="black"></v-tabs-slider>
      <v-tab key="art_registrados">
        Articulos Registrados
        <v-icon>mdi-content-save</v-icon>
      </v-tab>
      <v-tab key="art_nuevos">
        Articulo
        <v-icon>mdi-pencil-box</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab2" class="ti">
      <v-tab-item key="art_registrados">
        <v-data-table :headers="headers" :items="items" :search="search">
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-text-field
                class="text-xs-center"
                v-model="search"
                append-icon="mdi-magnify"
                label="Búsqueda"
                single-line
                hide-details
                dense
              >
              </v-text-field>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="getData()"> Refrescar </v-btn>
          </template>
        </v-data-table>
        <!-- <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" /> -->
      </v-tab-item>
      <v-tab-item key="art_nuevos">
        <v-form v-model="valid">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  readonly
                  v-model="editedItem.codigo"
                  label="Código"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="9">
                <v-text-field
                  v-model="editedItem.nombre"
                  label="Descripción"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>

              <v-col col="12" md="3" sm="6">
                <v-select
                  label="Tipo Articulo"
                  item-text="descripcion"
                  item-value="codigo"
                  v-model="editedItem.tipoArt"
                  :items="tiposArticulos"
                ></v-select>
              </v-col>

              <v-col col="12" md="3" sm="6">
                <v-select
                  label="Unidad"
                  item-text="un_nombre"
                  item-value="un_codigo"
                  v-model="editedItem.unidad"
                  :items="unidades"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  readonly
                  v-model="editedItem.tarifa"
                  label="Tarifa"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="editedItem.monto"
                  label="Precio"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="editedItem.existencia"
                  label="Existencia"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  readonly
                  v-model="editedItem.cabys"
                  label="Código Cabys"
                  required
                ></v-text-field>
              </v-col>

              <v-col align="center" cols="12" sm="6" md="3">
                <v-btn color="primary" dark class="mb-2" @click="mostrarCabys">
                  Buscar Cabys
                </v-btn>
              </v-col>

              <v-dialog transition="dialog-bottom-transition" v-model="dialog">
                <!--width="1000px"  -->
                <div v-if="showNewData">
                  <Cabys
                    v-bind:allwedOnly="true"
                    @clicked="selected"
                    @closed="closed"
                  />
                </div>
              </v-dialog>

              <v-col cols="12" sm="6" md="3">
                <v-text-field
                  v-model="editedItem.cia"
                  :rules="nameRules"
                  label="Cedula"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-if="visible"
                  v-model="editedItem.codigoTarifa"
                  label="Código Tarifa"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-if="visible"
                  v-model="editedItem.codigoImp"
                  label="Código Impuesto"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-if="visible"
                  v-model="editedItem.barras"
                  label=" Código Barras"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-if="visible"
                  v-model="editedItem.peso"
                  label="Peso"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  v-if="visible"
                  v-model="editedItem.costo"
                  label="Costo"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-row align="center" justify="space-around">
            <v-btn color="primary" :disabled="!incluirValid" @click="incluir()">
              Incluir
            </v-btn>
            <v-btn color="primary" :disabled="!guardarValid" @click="save()">
              Guardar
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!eliminarValid"
              @click="deleteItem()"
            >
              Eliminar
            </v-btn>
            <v-btn
              color="primary"
              :disabled="!cancelarValid"
              @click="cerrar()"
              dark
            >
              Cancelar
            </v-btn>
          </v-row>

          <v-container>
            <v-row align="center" justify="space-around"> </v-row>
          </v-container>
        </v-form>
      </v-tab-item>
      <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
    </v-tabs-items>
  </div>
</template>

<script>
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";
import Cabys from "./Cabys.vue";

export default {
  components: {
    Snackbar,
    Cabys,
  },
  dark: true,
  data() {
    return {
      dialog: false,
      valid: false,
      incluirValid: true,
      cancelarValid: false,
      eliminarValid: false,
      guardarValid: false,
      search: "",
      snackText: "",
      snackValue: false,
      tab2: "",
      headers: [
        {
          text: "Código",
          align: "start",
          value: "codigo",
        },
        {
          text: "Nombre",
          align: "start",
          value: "nombre",
        },
        {
          text: "Precio",
          align: "start",
          value: "monto",
        },
        {
          text: "Existencia",
          align: "start",
          value: "existencia",
        },
        { text: "Editar", value: "actions", width: 50, sortable: false },
      ],
      items: [],
      tiposArticulos: [],
      unidades: [],
      codigoArticulo: "",
      editedIndex: -1,
      editedItem: {
        codigo: "",
        nombre: "",
        tipoArt: "",
        unidad: "",
        tarifa: 0,
        monto: 0,
        barras: "",
        existencia: 0,
        costo: 0,
        peso: "",
        codigoImp: "",
        codigoTarifa: "",
        cabys: "",
        cia: "",
      },
      defaultItem: {
        codigo: "",
        nombre: "",
        tipoArt: "",
        unidad: "",
        tarifa: 0,
        monto: 0,
        barras: "",
        existencia: 0,
        costo: 0,
        peso: 0,
        codigoImp: "",
        codigoTarifa: "",
        cabys: "",
        cia: "",
      },
      cabys: {
        codigo: "",
        descripcion: "",
        impuesto: "",
      },
      showNewData: false,
      nameRules: [(v) => !!v || "Campo requerido"],
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    search() {
      this.snackValue = false;
    },
  },

  created() {
    this.getData();
    this.getTiposArticulos();
    this.getUnidades();
  },

  methods: {
    getData() {
      let me = this;
      axios
        .get("api/Articulos/getArticulosByCompany?cia=" + "3101302123", {
          crossdomain: true,
        })
        //.get("api/Sender/GetTipoDocumento", {crossdomain: true})
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
      //this.snackValue = false
    },

    getCodigoArticulo() {
      let me = this;
      axios
        .get("api/Articulos/getCodigoArticulo?cia=" + "3101302123")
        .then(function (response) {
          //me.codigoArticulo = response.data;
          me.editedItem.codigo = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTiposArticulos() {
      let me = this;
      axios
        .get("api/Articulos/getTipoArticulos")
        .then(function (response) {
          me.tiposArticulos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getUnidades() {
      let me = this;
      axios
        .get("api/Articulos/getUnidades")
        .then(function (response) {
          me.unidades = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      //this.dialog = true;
      this.tab2 = 1;
      this.cancelarValid = true;
      this.eliminarValid = true;
      this.guardarValid = true;
      this.incluirValid = false;
    },

    mostrarCabys() {
      this.dialog = true;
      this.showNewData = true;
      this.cancelarValid = true;
    },

    save() {
      let me = this;
      //me.snackValue = false;

      //   if (!this.editedItem.tipoArt && !this.editedItem.nombre && this.editedItem.tarifa >= 0
      //       && this.editedItem.monto > 0 && this.editedItem.existencia >= 0 && !this.editedItem.codigoImp
      //       && !this.editedItem.codigoTarifa  && !this.editedItem.cabys && !this.editedItem.cia) {
      if (this.editedIndex > -1) {
        axios
          .post("api/Articulos/updateArticulo", this.editedItem)
          .then(function () {
            me.snackText = "Registro modificado satisfactoriamente";
            me.snackValue = true;
            me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
      } else {
        axios
          .post("api/Articulos/insertArticulo", this.editedItem)
          .then(function () {
            me.snackText = "Registro agregado satisfactoriamente";
            me.snackValue = true;
            me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
      }
      this.cancelarValid = true;
      this.eliminarValid = true;
      this.guardarValid = true;
      this.incluirValid = false;
      this.snackValue = false;
      //   } else {
      //     me.snackText = "Por favor valide la información de los campos obligatorios";
      //     me.snackValue = true;
      //   }
      //this.close();
    },

    // validarCampos(){
    //     let me = this;

    //     if(this.editedItem.tipoArt === "") {
    //         return false;
    //     }
    //     else
    //     {
    //         return TRUE;
    //     }

    // },

    deleteItem() {
      let me = this;
      if (confirm("¿Está seguro de que desea eliminar el articulo?")) {
        axios
          .delete(
            "api/Articulos/deleteArticulo?cia=" +
              this.editedItem.cia +
              "&codigo=" +
              this.editedItem.codigo
          )
          .then(function () {
            me.getData();
          })
          .catch(function (error) {
            console.log(error);
            // me.saved(false);
          });
        this.cerrar();
        this.tab2 = 0;
      }
    },

    selected(value) {
      this.cabys = Object.assign({}, value);
      this.showNewData = false;
      this.dialog = false;
      //   this.snackText = "codigo: " + this.cabys.codigo + "descripcion: "+ this.cabys.descripcion + "impuesto: " +this.cabys.impuesto ;
      //   this.snackValue = true;
      this.editedItem.nombre = this.cabys.descripcion;
      this.editedItem.cabys = this.cabys.codigo;
      this.editedItem.tarifa = this.cabys.impuesto;
    },

    closed() {
      this.showNewData = false;
      this.dialog = false;
    },

    cerrar() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.valid = false;
        this.cancelarValid = false;
        this.eliminarValid = false;
        this.guardarValid = false;
        this.incluirValid = true;
        //this.$refs.form.resetValidation();
      });
    },

    incluir() {
      //this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.getCodigoArticulo();
        //this.valid = false;
        this.cancelarValid = true;
        this.eliminarValid = false;
        this.guardarValid = true;
        this.incluirValid = false;
        //this.$refs.form.resetValidation();
      });
    },
  },
};
</script>

<style>
.cd {
  overflow: scroll;
}

.v-tabs-items {
  overflow: auto;
}

.botonSalir {
  position: fixed;
  top: 5px;
  right: 5px;
}
</style>